import React from "react";
import { Badge, Spinner } from "reactstrap";

const STATUS_CONFIG = {
	pending: { label: "Pending", color: "secondary", icon: "fa-clock" },
	crawling: { label: "Crawling", color: "info", icon: "fa-spinner", spin: true },
	analyzing: { label: "Analyzing", color: "primary", icon: "fa-spinner", spin: true },
	running: { label: "Analyzing", color: "primary", icon: "fa-spinner", spin: true },
	completed: { label: "Completed", color: "success", icon: "fa-check-circle" },
	failed: { label: "Failed", color: "danger", icon: "fa-times-circle" },
	cancelled: { label: "Cancelled", color: "warning", icon: "fa-ban" },
};

const AuditStatusBadge = ({ status }) => {
	const s = String(status || "pending").toLowerCase();
	const config = STATUS_CONFIG[s] || { label: status, color: "secondary", icon: "fa-circle" };

	return (
		<Badge color={config.color} className="d-inline-flex align-items-center gap-1">
			{config.spin ? (
				<Spinner size="sm" style={{ width: "0.75rem", height: "0.75rem" }} />
			) : (
				<i className={`fas ${config.icon}`} style={{ fontSize: 10 }} />
			)}
			{config.label}
		</Badge>
	);
};

export default AuditStatusBadge;
